module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction",
      "role": "doc-introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION"), _c('br'), _c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "filet",
      "src": "images/filet.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('i', [_vm._v("Why")]), _vm._v(" "), _c('i', [_vm._v("a PENTECOSTAL")]), _vm._v(" GUIDE "), _c('i', [_vm._v("to the")]), _vm._v(" HOLY SPIRIT?")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "fig-013_1",
      "src": "images/CH_dingbat_5274_gray.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSIDERING THE WIDE ARRAY")]), _vm._v(" of sources on the Pentecostal and charismatic movements, do we really need another book on the Spirit? The gulf between the scholar’s chair and the church pew has never been wider. This book seeks to bridge the gap between serious study of the Bible and the need for practical discipleship in the church. In addition, current demographics demonstrate a need for a book like this. The number of believers who identify as Pentecostal or charismatic is growing at an astounding rate. This rapidly expanding sector of the church needs informed biblical study that addresses the role of the Holy Spirit in everyday life. This current work seeks to meet that need.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LARIFICATION OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMS:")]), _vm._v(" "), _c('i', [_vm._v("P")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ENTECOSTAL")])]), _vm._v(" . . . L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABEL OR")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENS?")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Labels are helpful when they serve to clarify, define, and describe. However, the limited value of a label becomes apparent as soon as it is applied. Every label has the tendency to fixate, restrict, and exclude. As such, no single label can fully capture all the aspects and values of a thing. Life simply has a way of escaping the confines of any label. This is especially true with religious labels. "), _c('i', [_vm._v("Reformed . . . evangelical . . . "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak",
      "title": "2"
    }
  }, [_vm._v("Pentecostal . . . ")])]), _vm._v("The very mention of these terms births such varied interpretations that, in short order, the label becomes meaningless. How then are we to label the living and dynamic presence of the Holy Spirit in the church? In other words, can the charismatic grace of the Spirit in the life of an increasingly diverse and global church be labeled?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In response, the term "), _c('i', [_vm._v("Pentecostal ")]), _vm._v("in this present study is not used as a "), _c('i', [_vm._v("label")]), _vm._v(" that defines but as a "), _c('i', [_vm._v("lens")]), _vm._v(" to look through. "), _c('i', [_vm._v("Pentecostal")]), _vm._v(" in this work does not refer to a specific denomination or even a particular historical religious phenomenon. Nor does it mean ascribing a cluster of Scriptures with an importance that goes beyond the rest of Holy Writ. Rather "), _c('i', [_vm._v("Pentecostal")]), _vm._v(", in this present context, refers to a special kind of interpretive grid. "), _c('i', [_vm._v("Pentecostal ")]), _vm._v("is being used here as a hermeneutical lens that informs all of reality—God, humanity, creation—and frames that reality as a seamless interplay of all that is true."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The truth-bearing theme that colors this lens is the living presence of the Spirit of God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Even so, what lies at the heart of "), _c('i', [_vm._v("Pentecostal ")]), _vm._v("so described? In brief, "), _c('i', [_vm._v("Pentecostal")]), _vm._v(" means the collapse of the transcendent. A "), _c('i', [_vm._v("Pentecostal ")]), _vm._v("lens is framed by this one central premise: God has become immanent among his people by way of the vibrant presence of the Holy Spirit (Rev 21:3). The power, the presence, and the praxis of the Spirit has invaded this world and established God’s people as a beachhead for the reclamation of all creation (Jas 1:18). In this sense there is a decidedly incarnational aspect to a "), _c('i', [_vm._v("Pentecostal ")]), _vm._v("interpretive grid. The Spirit inhabits the redeemed, and by way of the preeminent sacraments flowing from Jesus and the Scriptures, the Spirit empowers believers to see things as they really are (1 Cor 2:11-12). Paradoxically, the collapse of the transcendent births another kind of transcendence whereby those immersed in the Spirit are no longer defined by, or better, confined to this present world (Phil 3:20). As the faithful “walk in the Spirit” (Gal 5:16), "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak",
      "title": "3"
    }
  }, [_vm._v("the presence of the kingdom is brought forward and, in measure, realized in their lives.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All of this means that the task of interpretation (hermeneutics), the clear teaching of the Bible (exegesis), and the present state of the church (ecclesiology) call for a particularly Pentecostal guide on the Holy Spirit in the New Testament.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTECOSTAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENS FOR")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION:")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTH")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLISTIC AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTEGRATED")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("One can readily see that Spirit-centered interpretation has huge implications for experiencing God and understanding his Word. This way of engaging the Scriptures is both holistic and integrated. It is holistic in that it involves the human mind, heart, and spirit. The venue of the Spirit’s revelation is not confined to human thought but includes human emotion and worship as well (Lk 10:27). A Pentecostal approach is integrated because it knits together the shared experience of the Spirit across time. The generative Spirit at the dawn of creation (Gen 1:2) is the same Spirit that inspired and performed miracles through the prophets (Num 11:29). This is the same Spirit that not only conceived Jesus in the Virgin Mary (Lk 1:34-35), but also charismatically empowered Jesus throughout his life (Lk 4:18) and raised him from the dead (Rom 1:4). The charismatic Christ baptizes the church in the selfsame Spirit (Mt 3:11) and empowers the first believers to preach the gospel to the uttermost parts of the earth (Acts 1:8). This gospel is not only shared in word, but also in the miraculous power and demonstration of the Spirit (1 Cor 2:4).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In sum, a Pentecostal lens sees the primordial person and work of the Spirit to be the same person and work of the Spirit that has operated in the lives of the faithful throughout the ages, including our own. Regarding the ancients, their story of God is our story of God and their experience in the Spirit is our experience in the Spirit. In other words, there is an unencumbered merging of spiritual landscapes, the biblical world of the Spirit, and our present communion in the Spirit. In this way "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak",
      "title": "4"
    }
  }, [_vm._v("the contemporary believer participates in the life of the Spirit that has always been, now is, and will continue to be.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All of this tends to dismantle the “wall of separation” so evident in many modernist, Western modes of interpretation. By this I mean that artificial barrier constructed to distance academic study from spiritual formation. Yet "), _c('i', [_vm._v("Pentecostal")]), _vm._v(" does not mean the displacement of sound biblical scholarship by an unreflective devotional experience. For what lies at the heart of being Pentecostal is a profound sense of revelation. This means that the proto-revelation of the Spirit, that is, the Scriptures, is the authoritative touchstone for any Pentecostal study. Also, the Spirit does not reveal only in word, but also in the world (Luke 3:1-3). God speaks in history, so historical context itself is revelatory for the Pentecostal (Gal 4:4). Language . . . grammar . . . history . . . are all imbued with the Spirit and are part and parcel with God’s revelation. Yet this pluriform revelation is intended "), _c('i', [_vm._v("for ")]), _vm._v("us, to be active "), _c('i', [_vm._v("in ")]), _vm._v("us and expressed "), _c('i', [_vm._v("through ")]), _vm._v("us (Rom 10:8).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A Spirit-centered interpretation deconstructs that contrived partition that alienates reason from spirit, thought from heart, and mind from emotion. A Pentecostal rubric celebrates that divine sympathy with the Holy Trinity whereby the joy of the kingdom (Rom 14:17) and the heartfelt fruit of the Spirit (Gal 5:22-23) are an ever-present reality. At times, this divine-human dialogue exceeds the strictures of human speech. It is then that discourse is so directed by the Spirit as to express devotion in a language framed more by the grammar of heaven than of earth (Acts 2:4; 19:6; 1 Cor 14:39). All of this means that a Pentecostal lens replaces an anthropocentric understanding of “God” with the living communion of the resurrected Lord as mediated by the indwelling Spirit. Modern existentialism gives way to being “in Christ” (2 Cor 5:17) as transformed through the Spirit (2 Cor 3:18). There is no cessation of the gifts of God (Jas 1:17) but a continuation of divine benevolence granted for the common good (1 Cor 12:5-7).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Pentecostal interpretation does not objectify Scripture as an ancient artifact to be dissected and analyzed. Rather the Word is alive and exacts a more powerful interpretive effect on us than we on the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak",
      "title": "5"
    }
  }, [_vm._v("Word (Heb 4:12). This means that the Scriptures are to be studied devotionally (2 Tim 3:16-17). They were not given just to be mastered by human reason but to be obeyed by godly servants (Jas 1:22; 2:17). The revelation was not given to be domesticated so that it might accommodate modernity. Rather, the revelation itself becomes the archetype by which the children of God must conform and be changed (Rom 12:1-2). In other words, the original intent of the authors of Scripture has become paradigmatic for us and the Spirit expects us to respond accordingly (Rom 15:4).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTECOSTAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENS FOR")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATION:")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPREHENSIVE AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSMIC")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If all of this sounds like a dramatic and definitive mandate from on high . . . it is. The Pentecostal lens of interpretation provides a widescreen view that is both comprehensive and cosmic. It takes in everything, from beginning to end, and informs everything in between. This means that a Pentecostal lens of interpretation is necessarily an eschatological lens. The promised outpouring of the Holy Spirit on the first believers (Acts 2:1-21) marked the last days’ fulfillment of Joel’s prophecy (Joel 2:28). This end-time work of the Spirit not only empowers God’s select people but will also restore all creation (Rom 8:19-23). The coming of the Spirit is a momentous, end-time work of God on the order of the incarnation and ascension. The invasion of the Spirit at Pentecost was a paradigm-shaping event that altered the fabric of the cosmos for good (Acts 2:19‒20). This end-time reclamation of the Spirit started with those who are created in God’s image and so enshrined the saints that their physical bodies became the sole dwelling place of the Spirit on earth (1 Cor 6:19). The Spirit started with us, but it won’t end with us, for the Spirit himself is a kind of “first fruit” (Rom 8:23) or “down payment” (2 Cor 1:22) of the cosmic redemption of God yet to come (Eph 1:13-14).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It’s clear that for the Pentecostal, "), _c('i', [_vm._v("eschatological ")]), _vm._v("or "), _c('i', [_vm._v("end time")]), _vm._v(" does not mean “totally future.” For the Pentecostal, the outpouring of the Spirit represents a kind of prolepsis, or an advance consummation of all "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak",
      "title": "6"
    }
  }, [_vm._v("things in the here and now. To be sure, even as we presently “walk in the Spirit” (Rom 8:4), we “wait in the Spirit” (Gal 5:5) for our complete redemption. It is this anticipatory presence of the Spirit that “groans in our spirit” and eagerly looks forward to the redemption of our bodies (Rom 8:23). All of this means that for the Pentecostal, the distance between the “already” of God’s kingdom and the “not yet” of our present state has been narrowed. Indeed, a Pentecostal interpretation realizes that the separation of “this age” from the “age to come” is not an impenetrable separation but divinely permeable (Lk 11:20). By way of the Holy Spirit, the presence and powers of the kingdom of God are streaming into the life of the church even now (1 Cor 12:8-10).")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUND")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLICAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XEGESIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLS FOR A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTECOSTAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY OF THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When God established his covenant with the Hebrews of old, he was already announcing the coming of a qualitatively "), _c('i', [_vm._v("new ")]), _vm._v("covenant, one that was thoroughly infused by the Spirit (Jer 31:31-33). Ezekiel prophesies that God will put his Spirit into our hearts and cause us to walk in his statutes and observe his laws (Ezek 36:26-27). Following on, Jesus speaks of an organic connection between the new covenant in his blood (Lk 22:20) and the outpouring of the Holy Spirit on his disciples (Acts 1:4-5). The moment this promise is fulfilled in the church, a direct link is made with Joel’s prophecy concerning the last days outpouring of the Spirit (Acts 2:16-21). Luke consistently portrays the church as a charismatically empowered community that brings the redemptive power of the kingdom to bear by the power of the Spirit (Acts 8:13; 19:11-12). The same holds for the apostle Paul. By alluding to the prophecies of Jeremiah and Ezekiel, the apostle understands that a new covenant has been enacted by way of the Holy Spirit (2 Cor 3:2-3). For him, Spirit-filled Gentiles are the fulfillment of God’s covenant with Abraham (Gal 3:1-9). It is the “Spirit of adoption” (Rom 8:15) through whom they cry out, “Abba! Father!” (Gal 4:6). The writer of Revelation says that he “was in the Spirit on the Lord’s day” (Rev 1:10).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak",
      "title": "7"
    }
  }, [_vm._v("This rapid overview of the Scriptures yields an undeniable conclusion. The writers of the New Testament, from beginning to end, understand that the Christocentric plan of God was being realized by way of the Holy Spirit. This clear and consistent teaching of the Bible is of special interest to Pentecostals and charismatics and requires a special study of its own.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOBAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLS FOR A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTECOSTAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY OF THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The reported death of the church has been greatly exaggerated. The church is not dying; it has simply changed address. While there are signs of decline in the West, there is tremendous growth in the Global South, Africa, and China."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" A huge portion of this astonishing growth comprises those who self-identify as “Pentecostal” or “charismatic.” The findings of mega-studies such as "), _c('i', [_vm._v("World Christian Encyclopedia ")]), _vm._v("(2nd ed.) and the "), _c('i', [_vm._v("Pew Research Center for Religion and Public Life")]), _vm._v(" are astounding. The fact that these mega censuses devote entire sections to Pentecostals and charismatics is telling. For example, in 1900 the World Christian Database numbered Pentecostals and charismatics at less than a million. Today it is estimated that there are more than 670 million Pentecostals and charismatics worldwide."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Presently over 25 percent of Christendom is Pentecostal or charismatic. This same census projects that by 2050 the total number of Pentecostals and charismatics will be over a billion with one in three Christians claiming to be Pentecostal or charismatic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It becomes clear that any attempt to number Pentecostals and charismatics is like sampling a river. The very moment a cupful is taken, the subject matter has moved on. Any global census of the movement becomes outdated as soon as it is made. It is for this reason that thumbnail "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak",
      "title": "8"
    }
  }, [_vm._v("estimates range wildly. One estimate speaks of 40,000 Pentecostals and charismatics being added to the church daily, while another claims that the number is closer to 70,000! Thus, George Weigel asserts that Pentecostals and charismatics compose the fastest growing religious phenomenon in world religious history."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The data from the Pew Forum is no less impressive. Of the Protestants surveyed in nearly twenty nations in Central and South America, every nation but one reported being over 50 percent Pentecostal."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Protestants in three of these countries (Brazil, Panama, and Nicaragua) were determined to be at least 80 percent Pentecostal. Additionally, nearly 60 percent of Catholics in Brazil, the most populous Catholic country in South America, self-identify as charismatic. Similarly, charismatic Catholics in Panama number over 70 percent.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And then there is Africa. Beginning with the 1970s, the Christian population in Africa has increased fivefold. The largest portion of that growth has occurred among the Pentecostals and charismatics. While studying in Cambridge in the summer of 2018, I received two unsolicited comments from church leaders in Africa. Independently they both simply said, “Africa is Pentecostal.” Admittedly anecdotal and clearly an overstatement, their comments were telling. Closer to the truth is the Pew Forum’s claim that Pentecostals in all African nations, from top to bottom, number anywhere from 10 to 20 percent "), _c('i', [_vm._v("of the entire national population")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Due to a number of factors, not the least of which is what Fenggang Yang calls the “control apparatus,” the Christian population in China cannot be determined."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Yet, Christianity is the fastest growing religion in China. Yang estimates that by 2025 the Christian population in China will be over 160 million, making China the most populous "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_vm._v("Christian nation in the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" If the presence of global Pentecostals and charismatics is replicated in China, and by all indications this is the case, the numbers are staggering."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Nevertheless, the number of Pentecostals and charismatics is only part of the story. Their overall impact on global Christianity is noteworthy. More than twenty years ago Ralph Martin commented, “My research has led me to make a bold statement: In all of human history, no other non-political, non-militaristic, voluntary human movement has grown as rapidly as the Pentecostal-charismatic movement in the last 25 years.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Luis Lugo, the director of the Pew Forum project, went so far as to say that the faith is well on its way to becoming “Pentecostalized.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" John Allan speaks of the “relentless advance of Pentecostalism” that shows no sign of slowing down. He goes so far as to say that Pentecostalism may be the very thing that saves Christianity from oblivion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some reasons for this incredible growth were expressed by Harvey Cox over a quarter of a century ago. He says that the Pentecostals have tapped into “primal spirituality,” expressed in “primal speech,” lived out in “primal piety,” that births “primal hope.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Even though the reasons for the incredible growth of the Pentecostal and charismatic movements is beyond the scope of this work, the self-reported reason is practically universal: the living presence of the Holy Spirit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Moreover, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("even if the reasons for growth are debated, the effect of the movement is not. It is nothing short of a new Reformation, the consequences of which are even greater than the first Reformation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMARY")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOUGHTS")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The church of the first century would not have even used the terms "), _c('i', [_vm._v("Pentecostal")]), _vm._v(" or "), _c('i', [_vm._v("charismatic")]), _vm._v(". The miraculous presence and power of the Holy Spirit was a given and required no special labels. The unceasing benevolence of the Spirit as manifested in miraculous gifts was both normal and normative. It was just the way things worked among God’s people. For these reasons, the writers of Scripture simply address the saints as “the church.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Spiritually, the present status of the church is different from that of the first century, but we are getting closer by the moment. An ever-increasing portion of the global church self-identifies as Pentecostal or charismatic. So in answer to the question, “Why a "), _c('i', [_vm._v("Pentecostal")]), _vm._v(" guide to the Holy Spirit in the New Testament?” the simplest answer is, “Because the church requires it.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet there is one final reason why this kind of study is so critical for our times. This reason encompasses all other justifications for a Spirit-centered approach to the Scriptures and constitutes the unique contribution of this book. In the minds of many, the worlds of academia and the church have been alienated for far too long. What is desperately needed is what Alister McGrath calls an “organic theology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" What is required is a more dynamic interchange between the respective gifts of the scholar and the charisms of the saints; a more fluid dialogue between the academy and the church."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" This kind of interdependence "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_vm._v("must necessarily transfer the intent and expectations of the Spirit to those who study the Scriptures. Reciprocally, those who have given their lives to the study of Scripture must be heard by those who are filled with the Spirit. This means that the devotional intent of the New Testament must be part of a Spirit-centered study of the Bible. Yet historic and linguistic elements are part of the Spirit’s work as well. Furthermore, an approach that appropriates the selfsame Spirit that inspired the New Testament in the first place is an approach that expects the text to be believed and obeyed. Therefore, what Craig Keener calls an “epistemic commitment” to the claims of Scripture and to the living voice of the Spirit must be "), _c('i', [_vm._v("a priori")]), _vm._v(" assumptions for any Spirit-filled hermeneutic."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" It is this very assumption that guides and shapes every chapter of this book.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0